import type { DataTableColumnGroupDefinition } from "~types/dataTableColumnGroupDefinition.ts";
import { loadFromLocalStorage } from "~utilities/loadFromLocalStorage.ts";

const getDefaultColumns = (configuration: Array<DataTableColumnGroupDefinition>) => {
  return configuration
    .flatMap((group) => group.columns.filter((column) => column.defaultInColumnChooser))
    .map((column) => JSON.stringify(column.key));
};

const isValidLocalStorageColumns = (
  value: unknown,
  configuration: Array<DataTableColumnGroupDefinition>,
): value is string[] => {
  if (!Array.isArray(value)) {
    return false;
  }

  const allowedKeys = new Set(
    configuration.flatMap((group) => group.columns.map((column) => JSON.stringify(column.key))),
  );

  return value.every((item) => typeof item === "string" && allowedKeys.has(item));
};

export const getDataTableColumns = (
  localStorageKey: string,
  configuration: Array<DataTableColumnGroupDefinition>,
) => {
  const localStorageColumns = loadFromLocalStorage(localStorageKey);
  if (isValidLocalStorageColumns(localStorageColumns, configuration)) {
    return localStorageColumns;
  }

  return getDefaultColumns(configuration);
};